import clsx from "clsx";
import style from "./style.module.scss";

const LangSwitcher = ({ langs, className }) => {
  if (!langs) return null;

  // Not show switcher if one trad
  const langsFormated = Object.values(langs);
  if (langsFormated.length < 2) {
    return null;
  }

  return (
    <div className={clsx(style.langs, className)}>
      {langsFormated.map((lang) => (
        <a
          key={lang.code}
          href={lang.url}
          className={lang.active ? style.active : null}
        >
          {lang.language_code.toUpperCase()}
        </a>
      ))}
    </div>
  );
};

export default LangSwitcher;
